/* eslint-disable camelcase */
import { pushToDataLayer } from '../pushToDataLayer';

export const addPageLoadEvents = () => {
  const $pageLoad = $('.ga-page-load-events');

  if ($pageLoad.length) {
    const productName = $pageLoad.data('productname');
    const $productID = $pageLoad.data('product-id');
    switch ($pageLoad.data('pagetype')) {
      case 'article':
        pushToDataLayer({
          event: 'engagement',
          action: 'article-read',
          url: window.top.location
        });
        break;
      case 'productdetail': {
        pushToDataLayer({
          event: 'engagement',
          action: 'product-view',
          url: window.top.location
        });

        pushToDataLayer({
          event: 'ga4_view_product',
          ga4_data: {
            single_item_id: $productID,
            single_item_name: productName
          }
        });
        break;
      }
      default:
        break;
    }
  }
};
